export default "__VITE_ASSET__bl5O1G5e__"